import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana',
    age: '41 años',
    city: 'Medellín',
    text: 'Llevaba 3 años tomando ansiolíticos. En la semana 2 del sistema, dormí completa por primera vez. En el día 30, le dije adiós a la pastilla. Esto cambió mi vida.',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150&h=150'
  }, {
    name: 'Catalina',
    age: '38 años',
    city: 'Bogotá',
    text: 'Soy mamá de dos niños y trabajadora. El agotamiento era mi estado normal. Con este sistema aprendí a regular mi sistema nervioso en 10 minutos al día. Soy otra persona.',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150'
  }, {
    name: 'Valentina',
    age: '47 años',
    city: 'Cali',
    text: 'Lo intenté todo: yoga, meditación, terapia. Nada tocaba la raíz. Esto sí. El método R.E.S.T.A.U.R.A es lo que me faltaba. Llevo 4 meses y sigo aplicándolo.',
    img: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&q=80&w=150&h=150'
  }];
  return <section className="py-24 px-4 bg-beige" data-id="element-253">
      <div className="max-w-layout mx-auto" data-id="element-254">
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-255">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-sage/20 flex flex-col" data-id="element-256">
              <div className="flex text-gold mb-6" data-id="element-257">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-258" />)}
              </div>
              <p className="text-neutral-gray font-sans italic mb-8 leading-relaxed grow" data-id="element-259">
                "{t.text}"
              </p>
              <div className="flex items-center" data-id="element-260">
                <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-sage/30" data-id="element-261" />
                <div data-id="element-262">
                  <p className="font-heading font-bold text-teal" data-id="element-263">{t.name}</p>
                  <p className="text-xs text-sage-dark" data-id="element-264">
                    {t.age}, {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-gold/10 py-4 sm:py-5 px-4 sm:px-6 rounded-xl border-2 border-gold/40 shadow-md mx-2 sm:mx-0" data-id="element-265">
          <p className="font-heading font-bold text-teal text-sm sm:text-base md:text-lg leading-snug break-words" data-id="element-266">
            ⭐ +2.400 mujeres ya recuperaron su calma · 98% recomienda el
            sistema
          </p>
        </div>
      </div>
    </section>;
}